module.exports = __webpack_public_path__ + "img/node.d1a88f8e.png";